import { css } from "../../../styled-system/css";

export const styles = {
  section: css({
    backgroundColor: "white",
    width: "100%",
  }),

  headerRow: css({
    borderBottom: "1px solid",
    borderBottomColor: "disabledGrey",
    width: "100%",
  }),

  headerInner: css({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "baseUnit.mobile3",
    paddingLeft: "baseUnit.mobile2",
    paddingTop: "baseUnit.mobile5",
    paddingBottom: "baseUnit.mobile4",
    desktop: {
      paddingLeft: 0,
      paddingTop: "baseUnit.mobile9",
    },
  }),

  heading: css({
    margin: 0,
    flex: "1 0 0",
    fontSize: "heading.H1.mobile",
    fontWeight: 800,
    lineHeight: "heading.H1.mobile",
    letterSpacing: "heading.H1.mobile",
    color: "midnight",
    desktop: {
      fontSize: "heading.H1.desktop",
      lineHeight: "heading.H1.desktop",
      letterSpacing: "heading.H1.desktop",
    },
  }),

  controls: css({
    display: "none",
    desktop: {
      display: "flex",
      alignItems: "center",
      gap: "baseUnit.mobile1",
      flexShrink: 0,
    },
  }),

  counter: css({
    display: "none",
    margin: 0,
    fontSize: "body.butterfly",
    fontWeight: 400,
    lineHeight: "body.butterfly",
    letterSpacing: "body.butterfly",
    color: "midnight",
    opacity: 0.6,
    whiteSpace: "nowrap",
    alignSelf: "center",
    desktop: {
      display: "block",
      marginRight: "baseUnit.mobile1",
    },
  }),

  counterMobile: css({
    display: "block",
    margin: 0,
    marginTop: "baseUnit.mobile2",
    fontSize: "body.butterfly",
    fontWeight: 400,
    lineHeight: "body.butterfly",
    letterSpacing: "body.butterfly",
    color: "midnight",
    opacity: 0.6,
    whiteSpace: "nowrap",
    desktop: {
      display: "none",
    },
  }),

  carouselOuter: css({
    width: "100%",
    overflow: "hidden",
    touchAction: "pan-y",
    cursor: "grab",
    "&[data-dragging]": {
      cursor: "grabbing",
    },
    "--card-width": "100%",
    "--card-gap": "0px",
    paddingLeft: "baseUnit.mobile4",
    tablet: {
      "--card-width": "360px",
      "--card-gap": "24px",
      paddingLeft: "baseUnit.mobile4",
    },
    desktop: {
      "--card-width": "449px",
      "--card-gap": "24px",
      paddingLeft: "max(24px, calc((100vw - 1200px) / 2 + 24px))",
    },
  }),

  track: css({
    listStyle: "none",
    margin: 0,
    padding: 0,
    display: "flex",
    gap: "var(--card-gap)",
    willChange: "transform",
    transition: "transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)",
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none",
    },
  }),

  card: css({
    width: "var(--card-width)",
    flexShrink: 0,
    userSelect: "none",
    position: "relative",
    paddingTop: "baseUnit.mobile5",
    paddingBottom: "baseUnit.mobile5",
    paddingRight: "baseUnit.mobile4",
    tablet: {
      paddingRight: "baseUnit.mobile5",
    },
    desktop: {
      paddingTop: "baseUnit.mobile6",
      paddingBottom: "baseUnit.mobile6",
    },
  }),

  cardSeparator: css({
    display: "none",
    tablet: {
      display: "block",
      position: "absolute",
      top: "48px",
      bottom: "48px",
      right: 0,
      width: "1px",
      backgroundColor: "disabledGrey",
    },
  }),

  figure: css({
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: "baseUnit.mobile4",
    height: "100%",
    desktop: {
      gap: "baseUnit.mobile5",
    },
  }),

  blockquote: css({
    margin: 0,
    padding: 0,
    border: "none",
    display: "flex",
    flexDirection: "column",
    gap: "baseUnit.mobile2",
  }),

  quoteGlyphWrapper: css({
    height: "40px",
    overflow: "hidden",
    flexShrink: 0,
    desktop: {
      height: "56px",
    },
  }),

  quoteGlyph: css({
    display: "block",
    fontSize: "48px",
    fontWeight: 800,
    lineHeight: 1,
    color: "skyBlue",
    desktop: {
      fontSize: "80px",
    },
  }),

  quoteText: css({
    margin: 0,
    fontSize: "heading.H3.mobile",
    fontWeight: 800,
    lineHeight: "heading.H3.mobile",
    letterSpacing: "heading.H3.mobile",
    color: "midnight",
    desktop: {
      fontSize: "heading.H3.desktop",
      lineHeight: "heading.H3.desktop",
      letterSpacing: "heading.H3.desktop",
    },
  }),

  figcaption: css({
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    padding: 0,
    fontStyle: "normal",
    maxWidth: "none",
  }),

  dividerWrapper: css({
    paddingBottom: "10px",
  }),

  divider: css({
    display: "block",
    width: "32px",
    height: "2px",
    backgroundColor: "skyBlue",
  }),

  customerName: css({
    display: "block",
    fontSize: "body.shrimp",
    fontWeight: 800,
    lineHeight: "body.shrimp",
    letterSpacing: "body.shrimp",
    color: "midnight",
    textTransform: "uppercase",
  }),

  location: css({
    display: "block",
    fontSize: "body.butterfly",
    fontWeight: 400,
    lineHeight: "body.butterfly",
    letterSpacing: "body.butterfly",
    color: "midnight",
    opacity: 0.6,
  }),

  dotsRow: css({
    borderBottom: "1px solid",
    borderBottomColor: "disabledGrey",
    width: "100%",
  }),

  dotsInner: css({
    paddingLeft: "baseUnit.mobile2",
    paddingBottom: "baseUnit.mobile4",
    paddingTop: "baseUnit.mobile2",
    desktop: {
      paddingLeft: 0,
      paddingBottom: "baseUnit.mobile9",
    },
  }),

  dots: css({
    display: "flex",
    alignItems: "center",
    gap: "6px",
  }),

  dot: css({
    padding: 0,
    border: "none",
    borderRadius: "3px",
    backgroundColor: "darkGrey",
    opacity: 0.3,
    width: "6px",
    height: "6px",
    cursor: "pointer",
    flexShrink: 0,
    transition: "width 0.2s ease, opacity 0.2s ease, background-color 0.2s ease",
    "&[data-active]": {
      width: "24px",
      backgroundColor: "skyBlue",
      opacity: 1,
    },
    "&:focus-visible": {
      outline: "2px solid",
      outlineColor: "skyBlue",
      outlineOffset: "2px",
    },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none",
    },
  }),

  statsRow: css({
    width: "100%",
  }),

  statsList: css({
    display: "flex",
    flexDirection: "column",
    gap: "baseUnit.mobile4",
    paddingLeft: "baseUnit.mobile2",
    paddingTop: "baseUnit.mobile4",
    paddingBottom: "baseUnit.mobile4",
    desktop: {
      flexDirection: "row",
      gap: "baseUnit.mobile8",
      alignItems: "baseline",
      paddingLeft: 0,
    },
  }),

  statItem: css({
    display: "flex",
    alignItems: "baseline",
    gap: "9px",
    desktop: {
      gap: "baseUnit.mobile3",
    },
  }),

  statValue: css({
    fontSize: "heading.H2.mobile",
    fontWeight: 800,
    lineHeight: "heading.H2.mobile",
    letterSpacing: "heading.H2.mobile",
    color: "midnight",
    desktop: {
      fontSize: "heading.H2.desktop",
      lineHeight: "heading.H2.desktop",
      letterSpacing: "heading.H2.desktop",
    },
  }),

  statLabel: css({
    fontSize: "body.shrimp",
    fontWeight: 400,
    lineHeight: "body.shrimp",
    letterSpacing: "body.shrimp",
    color: "midnight",
  }),
};
